import { useCallback, useEffect, useState } from "react";
import MenuCM from "components/shared/menu";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Checkbox from "@mui/material/Checkbox";
import notfound from "assets/img/notfound.png";
import {
  StyledPaper,
  StyledTitleFilteBox,
  StyledTitleBorder,
  StyledTitleBorderDiv,
  StyledCategorieDiv,
  StyledCheckboxLabel,
  StyledProductsMainDiv,
  StyledProductsFlex,
  StyledProductDiv,
  StyledProductImg,
  StyledProductImgDiv,
  StyledProductTitle,
  StyledProductPrice,
  StyledSlideProductDiscount,
  StyledProductBeforePrice,
  StyledColorsProduct,
  StyledPaperTwo,
} from "./Furniture.style";
import ContactCM from "components/contactus";
import { PAGINATION_LIMIT_21, IMG_BASE_URL } from "constants";
import LoadingCM from "components/shared/Loading";
import PaginationCM from "components/shared/Pagination";
import useHttp from "hooks/use-http";
import {
  GetAccessoryProductsRequest,
  GetDesignWhitCategoryRequest,
} from "api/requests";
import { Link, useParams } from "react-router-dom";
import spliter from "helper/digit-spliter";
import FooterCM from "components/shared/footer";
import SkeletonCM from "components/shared/Skeleton";
import SkeletonProductCM from "components/shared/Skeleton/product";
import {Helmet} from "react-helmet";

const skeleton = [1, 2, 3, 4, 5, 6];

export default function Furniture() {
  const [checked, setChecked] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const { request, loading, setLoading } = useHttp();
  const params = useParams();

  const [page, setPage] = useState(1);
  const [productData, setProductData] = useState({
    data: [],
    count: 0,
  });
  const [designsData, setDesignsData] = useState({
    data: [],
    count: 0,
  });

  const handleToggle = async (event) => {
    // setChecked(event.target.value);
    const currentIndex = checked.indexOf(event.target.value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(event.target.value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    // getProductsFilters();
  };

  let filteredProduct = productData.data.filter((item) =>
    checked.includes(item.design_id)
  );

  //////////////// Get All Products Whit Category Id  ////////////////
  const getProducts = useCallback(
    async (search) => {
      const res = await request({
        url: GetAccessoryProductsRequest,
        values: {
          id: params.categoryId,
          skip: search ? 0 : (page - 1) * PAGINATION_LIMIT_21,
          // limit: search ? 100 : PAGINATION_LIMIT_21,
          limit: 100,
        },
      });
      setLoading(false);

      if (res) {
        if (res.count < 1) {
          return setProductData({
            count: res.count,
            data: [{ content: "هیچ محصولی یافت نشد" }],
          });
        }

        let transformedData = res.data.map((items) => ({
          id: items.id,
          title: items.title,
          price: items.price,
          image: items.image,
          design_id: items.design_id,
          discount_percent: items.discount_percent,
          before_discount_price: items.before_discount_price,
          colors: items.colors,
        }));

        setProductData({
          data: transformedData,
          count: res.count,
        });
      }
    },
    [page, request, setLoading, params.categoryId]
  );

  //////////////// Get All Designs Whit Category Id  ////////////////
  const getDesigns = useCallback(
    async (search) => {
      const res = await request({
        url: GetDesignWhitCategoryRequest,
        values: {
          id: params.categoryId,
          skip: search ? 0 : (page - 1) * PAGINATION_LIMIT_21,
          limit: search ? 100 : PAGINATION_LIMIT_21,
        },
      });
      setLoading(false);

      if (res) {
        if (res.count < 1) {
          return setDesignsData({
            count: res.count,
            data: [{ content: "هیچ طرحی برای فیلتر یافت نشد" }],
          });
        }

        let transformedData = res.data.map((items) => ({
          id: items.id,
          title: items.title,
          category: items?.category?.title,
        }));

        setDesignsData({
          data: transformedData,
          count: res.count,
        });
      }
    },
    [page, request, setLoading, params.categoryId]
  );

  useEffect(() => {
    if (productData.data.length < 1) {
      setPage(1);
    }
    getProducts();
    getDesigns();
    setChecked([]);
  }, [getProducts, getDesigns]);

  return (
    <>
      {/* {loading ? (
        <LoadingCM />
      ) : ( */}
      <Box>
        <Helmet>
          <title>مبلمان - مبلمان ویول</title>
          <meta name="product_id" content={""} />
          <meta name="product_name" content={""} />
          <meta name="product_price" content={""} />
          <meta name="product_old_price" content={""} />
          <meta name="availability" content={""} />
          <meta property="og:image" content={""} />
        </Helmet>
        <MenuCM
          Background
          pageTitle={designsData.data[0]?.category}
          pageCategory="مبلمان"
        />
        <Grid container spacing={2} direction="row">
          <Grid item lg={3} md={4} sm={12} xs={12}>
            <StyledPaper elevation={0} isOpen={isOpen}>
              {loading ? (
                <div style={{ textAlign: "center", border: "none" }}>
                  <SkeletonCM Width="40%" height={30} mBottom={30} mTop={10} />
                </div>
              ) : (
                <>
                  <StyledTitleFilteBox>فیلتر طرح</StyledTitleFilteBox>
                  <StyledTitleBorderDiv>
                    <StyledTitleBorder />
                  </StyledTitleBorderDiv>
                </>
              )}
              {loading ? (
                <div style={{ textAlign: "center", border: "none" }}>
                  <SkeletonCM height={30} mBottom={10} mTop={10} Count={5} />
                </div>
              ) : (
                <>
                  {designsData.count < 1
                    ? "هیچ طرحی برای فیلتر وجود ندارد"
                    : designsData.data?.map((design, index) => (
                        <StyledCategorieDiv key={index}>
                          <Checkbox
                            id={"category" + index}
                            onChange={handleToggle}
                            value={design.id}
                            // checked={checked.id}
                            sx={{
                              color: "#0080A1",
                              paddingLeft: "0",
                              "&.Mui-checked": {
                                color: "#0080A1",
                              },
                            }}
                          />
                          <StyledCheckboxLabel htmlFor={"category" + index}>
                            {design.title}
                          </StyledCheckboxLabel>
                        </StyledCategorieDiv>
                      ))}
                </>
              )}
            </StyledPaper>
            {loading ? (
              ""
            ) : (
              <StyledPaperTwo elevation={0} onClick={() => setIsOpen(!isOpen)}>
                {!isOpen ? (
                  <AddCircleOutlineIcon style={{ color: "#009AC2" }} />
                ) : (
                  <RemoveCircleOutlineIcon style={{ color: "#009AC2" }} />
                )}
              </StyledPaperTwo>
            )}
          </Grid>
          <Grid item lg={9} md={8} sm={12} xs={12}>
            <StyledProductsMainDiv>
              <StyledProductsFlex>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  {loading ? (
                    <>
                      {skeleton?.map((product, index) => (
                        <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
                          <SkeletonProductCM />
                        </Grid>
                      ))}
                    </>
                  ) : (
                    <>
                      {productData.count < 1
                        ? "هیچ محصولی در مبلمان وجود ندارد"
                        : checked.length < 1
                        ? productData.data?.map((product, index) => (
                            <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
                              <Link
                                to={`/product/${product.id}`}
                                key={"product" + index}
                                target={"_blank"}
                              >
                                <StyledProductDiv elevation={3}>
                                  <StyledProductImgDiv>
                                    {product.image ? (
                                      <StyledProductImg
                                        src={IMG_BASE_URL + product.image}
                                      />
                                    ) : (
                                      <StyledProductImg src={notfound} />
                                    )}
                                  </StyledProductImgDiv>
                                  <StyledColorsProduct>
                                    {product.colors?.map((color, index) => (
                                      <span
                                        key={"color" + index}
                                        style={{ background: color.color_code }}
                                      ></span>
                                    ))}
                                  </StyledColorsProduct>
                                  <StyledProductTitle>
                                    {product.title}
                                  </StyledProductTitle>
                                  {product.discount_percent !== 0 ? (
                                    <StyledProductBeforePrice>
                                      <span>
                                        {spliter(product.before_discount_price)}{" "}
                                        تومان
                                      </span>
                                    </StyledProductBeforePrice>
                                  ) : (
                                    <p
                                      style={{ height: "26px", margin: "0" }}
                                    ></p>
                                  )}
                                  <StyledProductPrice>
                                    {spliter(product.price)} تومان
                                  </StyledProductPrice>
                                  {product.discount_percent !== 0 ? (
                                    <StyledSlideProductDiscount>
                                      {" "}
                                      {product.discount_percent} %{" "}
                                    </StyledSlideProductDiscount>
                                  ) : (
                                    " "
                                  )}
                                </StyledProductDiv>
                              </Link>
                            </Grid>
                          ))
                        : filteredProduct?.map((product, index) => (
                            <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
                              <Link
                                to={`/product/${product.id}`}
                                key={"product" + index}
                                target={"_blank"}
                              >
                                <StyledProductDiv elevation={3}>
                                  <StyledProductImgDiv>
                                    {product.image ? (
                                      <StyledProductImg
                                        src={IMG_BASE_URL + product.image}
                                      />
                                    ) : (
                                      <StyledProductImg src={notfound} />
                                    )}
                                  </StyledProductImgDiv>
                                  <StyledColorsProduct>
                                    {product.colors?.map((color, index) => (
                                      <span
                                        key={"color" + index}
                                        style={{ background: color.color_code }}
                                      ></span>
                                    ))}
                                  </StyledColorsProduct>
                                  <StyledProductTitle>
                                    {product.title}
                                  </StyledProductTitle>
                                  {product.discount_percent !== 0 ? (
                                    <StyledProductBeforePrice>
                                      <span>
                                        {spliter(product.before_discount_price)}{" "}
                                        تومان
                                      </span>
                                    </StyledProductBeforePrice>
                                  ) : (
                                    <p
                                      style={{ height: "26px", margin: "0" }}
                                    ></p>
                                  )}
                                  <StyledProductPrice>
                                    {spliter(product.price)} تومان
                                  </StyledProductPrice>
                                  {product.discount_percent !== 0 ? (
                                    <StyledSlideProductDiscount>
                                      {" "}
                                      {product.discount_percent} %{" "}
                                    </StyledSlideProductDiscount>
                                  ) : (
                                    " "
                                  )}
                                </StyledProductDiv>
                              </Link>
                            </Grid>
                          ))}
                    </>
                  )}
                </Grid>
              </StyledProductsFlex>
            </StyledProductsMainDiv>
            {productData.data.length < 1 ? (
              <SkeletonCM Width="0px" height="0px" BackWrapper />
            ) : (
              " "
            )}
          </Grid>
        </Grid>
        <ContactCM Furniture />
        <FooterCM />
      </Box>
      {/* )} */}
    </>
  );
}
